"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.progress.complete': 'complete',
    'onboarding.progress.steps': 'steps',
};
